import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import {
  DataGrid,
  gridClasses,
  GridToolbarContainer,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import axios from "axios";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/DeleteOutlineOutlined";

const DraftTable = () => {
  const [draft, setDraft] = useState();
  const navigate = useNavigate();
  const storedUser = JSON.parse(localStorage.getItem("user"));

  const getSRAs = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/draft/get-all?username=${storedUser.username}`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setDraft(res.data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getSRAs();
  }, []);

  const handleCheck = (id) => {
    localStorage.setItem("activeTab", "DRAFTS");
    navigate(`/dashboard/create-sra/draft/${id}`);
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(
        `${process.env.REACT_APP_BACKEND_URL}/draft?draftSraId=${id}`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      getSRAs();
    } catch (error) {
      console.log(error);
    }
  };

  const columns = [
    {
      field: "draftSraId",
      headerName: "Draft ID",
      flex: 1,
      renderCell: (params) => (
        <span
          className="table-title"
          onClick={() => handleCheck(params.row.draftSraId)}
        >
          {params.row.draftSraId}
        </span>
      ),
    },
    {
      field: "pr",
      headerName: "Sourcing No.",
      flex: 1,
    },
    {
      field: "title",
      headerName: "Project Title",
      flex: 1,
    },
    {
      field: "category",
      headerName: "Category",
      flex: 1,
    },
    {
      field: "buyer",
      headerName: "Buyer Name",
      flex: 1,
    },
    {
      field: "createdDate",
      headerName: "Created Date",
      flex: 1,
    },
    {
      field: "action",
      headerName: "Action",
      flex: 1,
      renderCell: (params) => (
        <Button
          sx={{ padding: "0 !important", minWidth: "0px !important" }}
          onClick={() => handleDelete(params.row.draftSraId)}
          color="#c7c7c7"
        >
          <DeleteIcon />
        </Button>
      ),
    },
  ];

  const formatDateTime = (dateString) => {
    if (!dateString) return "";
    const [date, time] = dateString.split("T");
    const [year, month, day] = date.split("-");
    const cleanTime = time?.split(".")[0];
    return `${day}/${month}/${year} ${cleanTime}`;
  };

  const draftRows =
    draft &&
    draft.map((draft) => ({
      ...draft,
      createdDate: formatDateTime(draft.createdDate),
    }));

  return (
    <Box sx={{ background: "#fff" }}>
      <DataGrid
        rows={draftRows}
        columns={columns}
        //   loading={isLoading}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
        }}
        pageSizeOptions={[10]}
        disableRowSelectionOnClick
        disableColumnSelector
        disableDensitySelector
        disableColumnMenu
        disableColumnResize
        slots={{ toolbar: CustomToolbar }}
        getRowId={(row) => row.draftSraId}
        getRowClassName={(params) =>
          params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
        }
        sx={{
          border: "none",
          fontFamily: "Inter !important",

          "& .MuiDataGrid-columnHeaderTitle": {
            fontWeight: "700 !important",
          },
          "& .MuiDataGrid-columnHeaders": {
            background: "none !important",
            color: "black",
            fontSize: "14px",
            borderRadius: "10px",
          },
          "& .MuiDataGrid-row:hover": {
            backgroundColor: "#fff",
          },
          "& .MuiDataGrid-cell": {
            fontSize: "13px",
            border: "none",
          },
          "& .MuiDataGrid-columnSeparator": {
            display: "none",
          },
          "& .css-1ccsd5i-MuiButtonBase-root-MuiButton-root": {
            color: "#000 !important",
            border: "1px solid #B0B0B0",
            borderRadius: "12px",
            padding: 1,
          },
          "& .MuiInputBase-root-MuiInput-root::after": {
            borderBottom: "none !important",
          },
          "& .MuiInputBase-root-MuiInput-root": {
            borderBottom: "none !important",
          },
          [`& .${gridClasses.row}.even`]: {
            backgroundColor: "#EAF4FF",
            // '&:hover': {
            //   backgroundColor: "#f6f6f6",
            // },
          },
        }}
      />
    </Box>
  );
};

export default DraftTable;

function CustomToolbar() {
  return (
    <GridToolbarContainer sx={{ display: "flex", justifyContent: "end" }}>
      <GridToolbarQuickFilter
        style={{
          border: "1px solid var(--Neutral-300, #B0B0B0)",
          borderRadius: "12px",
          padding: 3,
        }}
      />
      {/* <GridToolbarFilterButton /> */}
    </GridToolbarContainer>
  );
}
